import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "pw-in-info" }
const _hoisted_3 = { class: "pw-in-name" }
const _hoisted_4 = {
  key: 0,
  class: "pw-in-num"
}
const _hoisted_5 = { class: "pw-in-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "pw-panel",
  "aria-label": "Telefone"
}
const _hoisted_10 = {
  key: 0,
  class: "pw-demo"
}
const _hoisted_11 = { class: "pw-head" }
const _hoisted_12 = { class: "pw-head-text" }
const _hoisted_13 = ["aria-checked", "aria-label"]
const _hoisted_14 = ["aria-pressed"]
const _hoisted_15 = {
  key: 1,
  class: "pw-settings"
}
const _hoisted_16 = {
  key: 0,
  class: "pw-problem"
}
const _hoisted_17 = {
  key: 1,
  class: "pw-hint"
}
const _hoisted_18 = { class: "pw-call-top" }
const _hoisted_19 = { class: "pw-call-info" }
const _hoisted_20 = { class: "pw-timer" }
const _hoisted_21 = { class: "pw-call-actions" }
const _hoisted_22 = ["aria-pressed", "onClick"]
const _hoisted_23 = {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_24 = {
  key: 0,
  x1: "2",
  y1: "2",
  x2: "22",
  y2: "22"
}
const _hoisted_25 = ["aria-pressed", "disabled", "onClick"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "pw-keypad",
  role: "group",
  "aria-label": "Teclado"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onSubmit"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "pw-tabs",
  role: "tablist"
}
const _hoisted_35 = ["aria-selected"]
const _hoisted_36 = ["aria-selected"]
const _hoisted_37 = {
  key: 0,
  class: "pw-badge"
}
const _hoisted_38 = {
  key: 3,
  class: "pw-recent"
}
const _hoisted_39 = {
  key: 0,
  class: "pw-recent-empty"
}
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "pw-recent-info" }
const _hoisted_42 = ["title", "aria-label", "onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "pw-keypad" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["aria-label"]
const _hoisted_48 = { class: "pw-fab-label" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import { loadLinkus, useLinkus } from '@/composables/useLinkus'
import { requestOpenChat } from '@/composables/useChatTrigger'
import { listMyCalls, type CallSummary } from '@/services/wootdashLinkus'
import { applySink, effectiveDevices, refreshDevices } from '@/composables/useAudioDevices'
import AudioDeviceSettings from '@/components/AudioDeviceSettings.vue'
import {
  answerCall, connectPhone, disconnectPhone, hangupCall, phonePreference, placeCall, rejectCall, sendDtmf, setPanelOpen,
  toggleHold, toggleMute, transferCall, useBrowserPhone, type PhoneCall,
} from '@/composables/useBrowserPhone'

type DemoCall = PhoneCall

export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneWidget',
  props: {
    sidebarOpen: { type: Boolean }
  },
  setup(__props: any) {

// Telefone no navegador (Yeastar WebRTC SDK): botão flutuante no canto, que abre o painel com o discador, as
// chamadas em andamento (mudo, espera, teclado, transferir, desligar) e a chamada recebida (atender/recusar, com o
// contato reconhecido e "Abrir conversa"). Só aparece pra quem pode ligar pelo Linkus (configurado + ramal).
const props = __props

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#']

const store = useStore()
const token = computed<string>(() => store.getters.authUser?.wootdash_token ?? '')
const userKey = computed<string | null>(() => store.getters.authUser?.email ?? null)
const { availability } = useLinkus()
const { phone } = useBrowserPhone()

// Demonstração (atalhos secretos): Ctrl+- mostra o painel/discador, Ctrl+, simula uma chamada recebida. Só a tela —
// nada vai pro PABX. Serve pra ver o visual antes de o Linkus estar configurado.
const demo = ref<{ calls: DemoCall[]; panelOpen: boolean } | null>(null)
const view = computed(() => demo.value
  ? { state: 'ready' as const, problem: null, extension: '1001', calls: demo.value.calls, panelOpen: demo.value.panelOpen, remoteStream: null }
  : phone)

function demoCall(direction: 'inbound' | 'outbound', number: string, name: string): DemoCall {
  return { callId: `demo-${Date.now()}`, number, name, direction, status: direction === 'inbound' ? 'ringing' : 'calling',
    isHold: false, isMute: false, talkingSince: null, contactId: null, conversationId: null, startedAt: Date.now(), rejected: false }
}
function onSecretKeys(e: KeyboardEvent) {
  if (!e.ctrlKey || e.altKey || e.metaKey) return
  if (e.key === '-' || e.code === 'Minus' || e.code === 'NumpadSubtract') {
    e.preventDefault()
    demo.value = demo.value ? null : { calls: [], panelOpen: true }
  } else if (e.key === ',' || e.code === 'Comma') {
    e.preventDefault()
    if (!demo.value) demo.value = { calls: [], panelOpen: false }
    demo.value.calls = [...demo.value.calls.filter(c => c.status !== 'ringing'), demoCall('inbound', '021959431661', 'Henrique (exemplo)')]
  }
}
function openPanel(open: boolean) {
  if (demo.value) demo.value.panelOpen = open
  else setPanelOpen(open)
}
/** Ação de um botão da chamada: no modo demonstração só mexe na tela. */
function act(kind: 'mute' | 'hold' | 'hangup', c: PhoneCall) {
  if (!demo.value) {
    if (kind === 'mute') toggleMute(c)
    else if (kind === 'hold') toggleHold(c)
    else if (kind === 'hangup') hangupCall(c.callId)
    return
  }
  const call = demo.value.calls.find(x => x.callId === c.callId)
  if (!call) return
  if (kind === 'mute') call.isMute = !call.isMute
  else if (kind === 'hold') call.isHold = !call.isHold
  else if (kind === 'hangup') demo.value.calls = demo.value.calls.filter(x => x.callId !== c.callId)
}

const available = computed(() => !!availability.value?.available || !!demo.value)
const left = computed(() => (props.sidebarOpen ? 220 : 64) + 16)
const incoming = computed(() => view.value.calls.filter(c => c.direction === 'inbound' && c.status === 'ringing'))
const active = computed(() => view.value.calls.filter(c => !(c.direction === 'inbound' && c.status === 'ringing')))

const audioEl = ref<HTMLAudioElement | null>(null)
const dialNumber = ref('')
const dialing = ref(false)
const keypadFor = ref<string | null>(null)
const transferFor = ref<string | null>(null)
const transferNumber = ref('')
const now = ref(Date.now())
const tab = ref<'dial' | 'recent'>('dial')
const realRecents = ref<CallSummary[]>([])
const DEMO_RECENTS: CallSummary[] = [
  { id: 'd1', number: '021959431661', direction: 'Inbound', source: 'Browser', outcome: 'Answered', startedAt: new Date(Date.now() - 12 * 60000).toISOString(), talkSeconds: 252, contactId: null, contactName: 'Henrique (exemplo)', conversationId: null },
  { id: 'd2', number: '011987654321', direction: 'Outbound', source: 'Browser', outcome: 'NoAnswer', startedAt: new Date(Date.now() - 50 * 60000).toISOString(), talkSeconds: null, contactId: null, contactName: 'Maria (exemplo)', conversationId: null },
  { id: 'd3', number: '021933334444', direction: 'Inbound', source: 'Browser', outcome: 'Missed', startedAt: new Date(Date.now() - 3 * 3600000).toISOString(), talkSeconds: null, contactId: null, contactName: null, conversationId: null },
]
const recents = computed(() => demo.value ? DEMO_RECENTS : realRecents.value)
const missedCount = computed(() => recents.value.filter(r => r.outcome === 'Missed' && Date.now() - new Date(r.startedAt).getTime() < 86400000).length)
async function loadRecents() {
  if (token.value && available.value && !demo.value) realRecents.value = await listMyCalls(token.value)
}
function recentLabel(r: CallSummary) {
  const talk = r.talkSeconds ? ` · ${Math.floor(r.talkSeconds / 60)}min ${String(r.talkSeconds % 60).padStart(2, '0')}s` : ''
  return {
    Answered: (r.direction === 'Inbound' ? 'Recebida' : 'Feita') + talk,
    NoAnswer: 'Não atendeu',
    Missed: 'Perdida',
    Rejected: 'Recusada',
    Failed: 'Não completou',
    Requested: 'Pelo Linkus',
  }[r.outcome]
}
function recentClass(r: CallSummary) {
  return r.outcome === 'Answered' ? 'ok' : r.outcome === 'Missed' || r.outcome === 'Rejected' ? 'bad' : 'muted'
}
function when(iso: string) {
  const d = new Date(iso)
  const today = new Date().toDateString() === d.toDateString()
  return today ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}
function redial(r: CallSummary) {
  tab.value = 'dial'
  dialNumber.value = r.number
  void dial()
}
let tick: ReturnType<typeof setInterval> | null = null

const stateLabel = computed(() => ({
  off: 'Desligado',
  connecting: 'Conectando ao PABX…',
  ready: `Pronto · ramal ${view.value.extension}`,
  error: 'Com problema',
}[view.value.state]))

function callStatusLabel(c: PhoneCall) {
  if (c.isHold) return 'em espera'
  return { ringing: 'tocando', calling: 'chamando…', connecting: 'conectando…', talking: 'em ligação' }[c.status]
}
function timer(since: number) {
  const s = Math.max(0, Math.floor((now.value - since) / 1000))
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
}
function fmtNumber(n: string) {
  const d = n.replace(/\D/g, '').replace(/^0+/, '').replace(/^55(?=\d{10,11}$)/, '')
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return n
}

async function togglePhone() {
  if (demo.value) { demo.value = null; return }
  if (phone.state === 'off' || phone.state === 'error') await connectPhone(token.value, userKey.value)
  else disconnectPhone(userKey.value)
}

async function dial() {
  if (demo.value) {
    const call = demoCall('outbound', dialNumber.value.trim(), dialNumber.value.trim())
    demo.value.calls = [...demo.value.calls, call]
    dialNumber.value = ''
    setTimeout(() => { const c = demo.value?.calls.find(x => x.callId === call.callId); if (c) { c.status = 'talking'; c.talkingSince = Date.now() } }, 2500)
    return
  }
  dialing.value = true
  try {
    await placeCall(dialNumber.value.trim())
    dialNumber.value = ''
  } catch (e) {
    Swal.fire({ icon: 'warning', title: 'Não deu pra ligar', text: (e as Error).message })
  } finally {
    dialing.value = false
  }
}
async function answer(c: PhoneCall) {
  if (demo.value) {
    const call = demo.value.calls.find(x => x.callId === c.callId)
    if (call) { call.status = 'talking'; call.talkingSince = Date.now() }
    demo.value.panelOpen = true
    return
  }
  try {
    await answerCall(c.callId)
    setPanelOpen(true)
  } catch (e) {
    Swal.fire({ icon: 'warning', title: 'Não deu pra atender', text: (e as Error).message })
  }
}
function reject(c: PhoneCall) {
  if (demo.value) { demo.value.calls = demo.value.calls.filter(x => x.callId !== c.callId); return }
  rejectCall(c.callId)
}
function transfer(c: PhoneCall) {
  if (demo.value) { demo.value.calls = demo.value.calls.filter(x => x.callId !== c.callId); transferFor.value = null; transferNumber.value = ''; return }
  transferCall(c.callId, transferNumber.value.trim())
  transferNumber.value = ''
  transferFor.value = null
}
function openConversation(c: PhoneCall) {
  if (c.conversationId) requestOpenChat(c.conversationId)
}

// Áudio da chamada no <audio> (o SDK entrega o MediaStream; quem toca é o navegador).
watch(() => phone.remoteStream, stream => {
  if (audioEl.value) audioEl.value.srcObject = (stream as MediaStream | null) ?? null
})

// ── Dispositivos de áudio (escolha e teste em AudioDeviceSettings.vue / useAudioDevices.ts) ──────────
const settingsOpen = ref(false)
function toggleSettings() { settingsOpen.value = !settingsOpen.value }

// A conversa sai pela saída escolhida (e volta pro padrão se o dispositivo sumir).
watch([audioEl, () => effectiveDevices.value.speakerId], ([el, id]) => { void applySink(el, id) }, { immediate: true })

// Liga sozinho se o agente deixou ligado da última vez.
watch([available, token], ([ok, t]) => {
  if (ok && t && phone.state === 'off' && phonePreference(userKey.value)) connectPhone(t, userKey.value)
}, { immediate: true })

watch(() => [phone.historyVersion, phone.state, phone.panelOpen], () => { if (phone.panelOpen && phone.state === 'ready') loadRecents() })

onMounted(() => {
  void loadLinkus(token.value)
  tick = setInterval(() => { now.value = Date.now() }, 1000)
  window.addEventListener('keydown', onSecretKeys)
  // Lista os dispositivos (sem pedir permissão) pra saber se o escolhido ainda está conectado.
  void refreshDevices()
})
onBeforeUnmount(() => {
  if (tick) clearInterval(tick)
  window.removeEventListener('keydown', onSecretKeys)
})

return (_ctx: any,_cache: any) => {
  return (available.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["pw", { 'pw--open': view.value.panelOpen }]),
        style: _normalizeStyle({ left: `${left.value}px` })
      }, [
        _createElementVNode("audio", {
          ref_key: "audioEl",
          ref: audioEl,
          autoplay: "",
          playsinline: "",
          class: "pw-audio"
        }, null, 512),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incoming.value, (c) => {
          return (_openBlock(), _createElementBlock("div", {
            key: c.callId,
            class: "pw-incoming",
            role: "alertdialog",
            "aria-label": `Chamada de ${c.name}`
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", {
              class: "pw-in-pulse",
              "aria-hidden": "true"
            }, [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.4 11.4 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "pw-in-label" }, "Chamada recebida", -1)),
              _createElementVNode("b", _hoisted_3, _toDisplayString(c.name), 1),
              (c.name !== c.number)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fmtNumber(c.number)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "pw-round pw-round--reject",
                title: "Recusar",
                "aria-label": "Recusar",
                onClick: ($event: any) => (reject(c))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85a.98.98 0 0 1-1.38-.02L.29 13.08a.96.96 0 0 1 0-1.37C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.71c.38.38.38 1 0 1.37l-2.51 2.47a.98.98 0 0 1-1.38.02 11.6 11.6 0 0 0-2.66-1.85.99.99 0 0 1-.56-.9v-3.1A15.3 15.3 0 0 0 12 9z" })
                ], -1)
              ]))], 8, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                class: "pw-round pw-round--answer",
                title: "Atender",
                "aria-label": "Atender",
                onClick: ($event: any) => (answer(c))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.4 11.4 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" })
                ], -1)
              ]))], 8, _hoisted_7)
            ]),
            (c.conversationId)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "pw-link pw-in-open",
                  onClick: ($event: any) => (openConversation(c))
                }, "Abrir conversa", 8, _hoisted_8))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1))
        }), 128)),
        (view.value.panelOpen)
          ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
              (demo.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Demonstração — nada é ligado de verdade. Ctrl+- fecha, Ctrl+, simula uma chamada."))
                : _createCommentVNode("", true),
              _createElementVNode("header", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(["pw-dot", `pw-dot--${view.value.state}`]),
                  "aria-hidden": "true"
                }, null, 2),
                _createElementVNode("div", _hoisted_12, [
                  _cache[10] || (_cache[10] = _createElementVNode("b", null, "Telefone", -1)),
                  _createElementVNode("small", null, _toDisplayString(stateLabel.value), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "pw-switch",
                  role: "switch",
                  "aria-checked": view.value.state !== 'off',
                  "aria-label": view.value.state === 'off' ? 'Ligar o telefone' : 'Desligar o telefone',
                  onClick: togglePhone
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("span", null, null, -1)
                ]))], 8, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["pw-icon", { on: settingsOpen.value }]),
                  title: "Dispositivos de áudio",
                  "aria-label": "Dispositivos de áudio",
                  "aria-pressed": settingsOpen.value,
                  onClick: toggleSettings
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "3"
                    }),
                    _createElementVNode("path", { d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" })
                  ], -1)
                ]))], 10, _hoisted_14),
                _createElementVNode("button", {
                  type: "button",
                  class: "pw-icon",
                  title: "Minimizar",
                  "aria-label": "Minimizar",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openPanel(false)))
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round"
                  }, [
                    _createElementVNode("line", {
                      x1: "5",
                      y1: "12",
                      x2: "19",
                      y2: "12"
                    })
                  ], -1)
                ]))])
              ]),
              (settingsOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[14] || (_cache[14] = _createElementVNode("b", { class: "pw-set-title" }, "Dispositivos de áudio", -1)),
                    _createVNode(AudioDeviceSettings, {
                      compact: "",
                      "call-active": active.value.length > 0
                    }, null, 8, ["call-active"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "pw-btn pw-btn--done",
                      onClick: toggleSettings
                    }, "Pronto")
                  ]))
                : _createCommentVNode("", true),
              (!settingsOpen.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (view.value.problem)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(view.value.problem), 1))
                      : (view.value.state === 'off')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Ligue pra fazer e receber ligações aqui no navegador, pelo seu ramal. O navegador vai pedir o microfone. "))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(active.value, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.callId,
                        class: "pw-call"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("b", null, _toDisplayString(c.name), 1),
                            _createElementVNode("span", null, _toDisplayString(c.name !== c.number ? fmtNumber(c.number) + ' · ' : '') + _toDisplayString(callStatusLabel(c)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(c.talkingSince ? timer(c.talkingSince) : ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["pw-act", { on: c.isMute }]),
                            "aria-pressed": c.isMute,
                            onClick: ($event: any) => (act('mute', c))
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_23, [
                              _cache[15] || (_cache[15] = _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }, null, -1)),
                              _cache[16] || (_cache[16] = _createElementVNode("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, null, -1)),
                              _cache[17] || (_cache[17] = _createElementVNode("line", {
                                x1: "12",
                                y1: "19",
                                x2: "12",
                                y2: "23"
                              }, null, -1)),
                              (c.isMute)
                                ? (_openBlock(), _createElementBlock("line", _hoisted_24))
                                : _createCommentVNode("", true)
                            ])),
                            _createTextVNode(" " + _toDisplayString(c.isMute ? 'Sem mudo' : 'Mudo'), 1)
                          ], 10, _hoisted_22),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["pw-act", { on: c.isHold }]),
                            "aria-pressed": c.isHold,
                            disabled: c.status !== 'talking',
                            onClick: ($event: any) => (act('hold', c))
                          }, [
                            _cache[18] || (_cache[18] = _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            }, [
                              _createElementVNode("line", {
                                x1: "9",
                                y1: "5",
                                x2: "9",
                                y2: "19"
                              }),
                              _createElementVNode("line", {
                                x1: "15",
                                y1: "5",
                                x2: "15",
                                y2: "19"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(c.isHold ? 'Retomar' : 'Espera'), 1)
                          ], 10, _hoisted_25),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["pw-act", { on: keypadFor.value === c.callId }]),
                            disabled: c.status !== 'talking',
                            onClick: ($event: any) => {keypadFor.value = keypadFor.value === c.callId ? null : c.callId; transferFor.value = null}
                          }, [...(_cache[19] || (_cache[19] = [
                            _createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b405562><circle cx=\"6\" cy=\"5\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"12\" cy=\"5\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"18\" cy=\"5\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"6\" cy=\"11\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"12\" cy=\"11\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"18\" cy=\"11\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"6\" cy=\"17\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"12\" cy=\"17\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"18\" cy=\"17\" r=\"1.6\" data-v-2b405562></circle><circle cx=\"12\" cy=\"22\" r=\"1.6\" data-v-2b405562></circle></svg> Teclado ", 2)
                          ]))], 10, _hoisted_26),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["pw-act", { on: transferFor.value === c.callId }]),
                            disabled: c.status !== 'talking',
                            onClick: ($event: any) => {transferFor.value = transferFor.value === c.callId ? null : c.callId; keypadFor.value = null}
                          }, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                              _createElementVNode("line", {
                                x1: "10",
                                y1: "14",
                                x2: "21",
                                y2: "3"
                              }),
                              _createElementVNode("path", { d: "M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" })
                            ], -1),
                            _createTextVNode(" Transferir ", -1)
                          ]))], 10, _hoisted_27),
                          _createElementVNode("button", {
                            type: "button",
                            class: "pw-act pw-act--hangup",
                            onClick: ($event: any) => (act('hangup', c))
                          }, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", { d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85a.98.98 0 0 1-1.38-.02L.29 13.08a.96.96 0 0 1 0-1.37C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.71c.38.38.38 1 0 1.37l-2.51 2.47a.98.98 0 0 1-1.38.02 11.6 11.6 0 0 0-2.66-1.85.99.99 0 0 1-.56-.9v-3.1A15.3 15.3 0 0 0 12 9z" })
                            ], -1),
                            _createTextVNode(" Desligar ", -1)
                          ]))], 8, _hoisted_28)
                        ]),
                        (keypadFor.value === c.callId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(KEYS, (k) => {
                                return _createElementVNode("button", {
                                  key: k,
                                  type: "button",
                                  onClick: ($event: any) => (demo.value ? undefined : _unref(sendDtmf)(c.callId, k))
                                }, _toDisplayString(k), 9, _hoisted_30)
                              }), 64))
                            ]))
                          : _createCommentVNode("", true),
                        (transferFor.value === c.callId)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 1,
                              class: "pw-transfer",
                              onSubmit: _withModifiers(($event: any) => (transfer(c)), ["prevent"])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((transferNumber).value = $event)),
                                class: "pw-input",
                                inputmode: "tel",
                                placeholder: "Ramal ou número",
                                "aria-label": "Transferir para"
                              }, null, 512), [
                                [_vModelText, transferNumber.value]
                              ]),
                              _createElementVNode("button", {
                                type: "submit",
                                class: "pw-btn",
                                disabled: !transferNumber.value.trim()
                              }, "Transferir", 8, _hoisted_32)
                            ], 40, _hoisted_31))
                          : _createCommentVNode("", true),
                        (c.conversationId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "pw-link",
                              onClick: ($event: any) => (openConversation(c))
                            }, "Abrir conversa", 8, _hoisted_33))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (view.value.state === 'ready' && !active.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": tab.value === 'dial',
                            class: _normalizeClass({ on: tab.value === 'dial' }),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'dial'))
                          }, "Discador", 10, _hoisted_35),
                          _createElementVNode("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": tab.value === 'recent',
                            class: _normalizeClass({ on: tab.value === 'recent' }),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (tab.value = 'recent'))
                          }, [
                            _cache[22] || (_cache[22] = _createTextVNode(" Recentes", -1)),
                            (missedCount.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(missedCount.value), 1))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_36)
                        ]))
                      : _createCommentVNode("", true),
                    (view.value.state === 'ready' && !active.value.length && tab.value === 'recent')
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                          (!recents.value.length)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_39, "Nenhuma ligação ainda."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recents.value, (r) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: r.id,
                              class: "pw-recent-row"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["pw-recent-ico", recentClass(r)]),
                                title: recentLabel(r),
                                "aria-hidden": "true"
                              }, _toDisplayString(r.direction === 'Inbound' ? '↙' : '↗'), 11, _hoisted_40),
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("b", null, _toDisplayString(r.contactName || fmtNumber(r.number)), 1),
                                _createElementVNode("span", null, _toDisplayString(recentLabel(r)) + " · " + _toDisplayString(when(r.startedAt)), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "pw-recent-call",
                                title: `Ligar pra ${r.contactName || r.number}`,
                                "aria-label": `Ligar pra ${r.contactName || r.number}`,
                                onClick: ($event: any) => (redial(r))
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.4 11.4 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" })
                                ], -1)
                              ]))], 8, _hoisted_42),
                              (r.conversationId)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "pw-recent-open",
                                    title: "Abrir conversa",
                                    "aria-label": "Abrir conversa",
                                    onClick: ($event: any) => (_unref(requestOpenChat)(r.conversationId!))
                                  }, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("svg", {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                                    ], -1)
                                  ]))], 8, _hoisted_43))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (view.value.state === 'ready' && !active.value.length && tab.value === 'dial')
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 4,
                          class: "pw-dial",
                          onSubmit: _withModifiers(dial, ["prevent"])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialNumber).value = $event)),
                            class: "pw-input pw-input--big",
                            inputmode: "tel",
                            placeholder: "Número ou ramal",
                            "aria-label": "Número pra ligar"
                          }, null, 512), [
                            [_vModelText, dialNumber.value]
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(KEYS, (k) => {
                              return _createElementVNode("button", {
                                key: k,
                                type: "button",
                                onClick: ($event: any) => (dialNumber.value += k)
                              }, _toDisplayString(k), 9, _hoisted_45)
                            }), 64))
                          ]),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "pw-call-btn",
                            disabled: !dialNumber.value.trim() || dialing.value
                          }, [
                            _cache[25] || (_cache[25] = _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", { d: "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.4 11.4 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(dialing.value ? 'Chamando…' : 'Ligar'), 1)
                          ], 8, _hoisted_46)
                        ], 32))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!view.value.panelOpen)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: _normalizeClass(["pw-fab", `pw-fab--${view.value.state}`]),
              "aria-label": `Telefone: ${stateLabel.value}`,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (openPanel(true)))
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.4 11.4 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z" })
              ], -1)),
              _createElementVNode("span", _hoisted_48, _toDisplayString(active.value.length ? `${active.value[0].name} · ${active.value[0].talkingSince ? timer(active.value[0].talkingSince) : callStatusLabel(active.value[0])}` : view.value.state === 'ready' ? `Ramal ${view.value.extension}` : 'Telefone'), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["pw-dot", `pw-dot--${view.value.state}`]),
                "aria-hidden": "true"
              }, null, 2)
            ], 10, _hoisted_47))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}
}

})